import { gql } from "@apollo/client";
import { print } from "graphql";
import { CartResponse } from "./fragments/CartResponse";

const REMOVE_LINE_ITEM_GQL = gql`
    ${CartResponse}

    mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
        cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
            cart {
                ...CartResponse
            }
            userErrors {
                field
                message
            }
        }
    }
`;

export const REMOVE_LINE_ITEM = print(REMOVE_LINE_ITEM_GQL) 